// frontend/app/components/admin/adminLessonColors.js
//
// The admin panel's palette, in the shape the lesson authoring components ask
// for.
//
// InternalAdminPanel.js is not theme-aware: no ThemeContext, no isDarkMode, one
// StyleSheet of light literals. The lesson library reuses BlockEditor and the
// WizardFields primitives, and those take a `colors` object — so the object is
// filled with the panel's own literals rather than with getLessonColors(). A
// themed island inside an unthemed screen would be a divergence, and the two
// palettes are close enough that only the divergence would show.
//
// Frozen because it is module-level shared state, and a component that wrote to
// it would repaint every admin screen at once.

export const ADMIN_LESSON_COLORS = Object.freeze({
  // Brand and surfaces — the panel's primaryBtn blue and adminCard white.
  accentPrimary: "#0077B6",
  accentGlow: "rgba(0, 119, 182, 0.10)",
  panelBg: "#ffffff",
  subtleBg: "#f7fafc",

  // Borders: the card border and the slightly darker input border.
  border: "#e6edf2",
  borderStrong: "#d8e0e8",

  textPrimary: "#25313d",
  textSecondary: "#5a6772",
  textMuted: "#6b7785",

  // Outcome colours, taken from the panel's own success and error blocks.
  success: "#1a7f4b",
  danger: "#c0392b",
  warning: "#b26a00",
  info: "#0077B6",

  correctBg: "#e8f6ee",
  correctBorder: "#bfe6d0",
  incorrectBg: "#fdf3f3",
  incorrectBorder: "#f3d2d2",

  // Warnings that are read rather than glanced at: the unlock consequence, and
  // a block the server would refuse.
  teacherTipBg: "#fdf6e3",
  teacherTipBorder: "#f0dfae",
  teacherTipText: "#7a5b00",

  aiCardBg: "#eaf4fa",
  aiCardBorder: "#c3dfee",
});

export default ADMIN_LESSON_COLORS;
